var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 100 100"}},[_c('title',[_vm._v("star")]),_c('path',{attrs:{"d":"M50,2.92,65.13,34.14,99.5,38.89l-25,24,6.1,34.15L50,80.72,19.4,97.08l6.11-34.15-25-24,34.37-4.75Z"}})])}
var staticRenderFns = []

export { render, staticRenderFns }